<template>
  <button
    :style="{
      padding: padding,
      height: height,
      width: width,
      fontSize: fontSize,
      border: border,
      color: color,
    }"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  props: {
    padding: {
      type: String,
      default: "8px",
    },
    height: {
      type: String,
    },
    width: {
      type: String,
    },
    fontSize: {
      type: String,
    },
    border: {
      type: String,
    },
    color: {
      type: String,
      default: "#fff",
    },
    fill: {
      type: String,
      default: "#fff",
    },
    svgHeight: {
      type: String
    },
  },
};
</script>

<style scoped>
button {
  background: transparent;
  border: 1px solid #fff;
  color: #fff;
  padding: 8px;

  display: flex;
  justify-content: center;
  align-items: center;
}

button:hover,
button:active {
  background: rgba(0, 0, 0, 0.17);
  border: 1px solid rgba(0, 0, 0, 0.17);
}
</style>